// extracted by mini-css-extract-plugin
export default {"issueRow":"issueRow---_vGQo","copiesPill":"copiesPill---vt9ks","issueDate":"issueDate---ZGGGC"};